import { render, staticRenderFns } from "./COA-Powder.vue?vue&type=template&id=09aa8872&scoped=true&"
import script from "./COA-Powder.vue?vue&type=script&lang=js&"
export * from "./COA-Powder.vue?vue&type=script&lang=js&"
import style0 from "./COA-Powder.vue?vue&type=style&index=0&id=09aa8872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa8872",
  null
  
)

export default component.exports